import React, { useEffect, useRef } from "react";
import { IAvatarSettings, SUBSCRIPTION_CODES } from "../../utils/types";
import styles from "./Viewer.module.scss";

const IFRAME_TARGET_ORIGIN: string = process.env["NX_PUBLIC_IFRAME_ADDRESS"] || "";
const IFRAME_TARGET_ORIGIN_LOWPOLY: string = process.env["NX_PUBLIC_LOWPOLY"] || "";

console.log(`IFRAME_TARGET_ORIGIN: ${IFRAME_TARGET_ORIGIN}`);

export const Viewer = ({ settings, lang }: { settings: IAvatarSettings, lang: 'ru' | 'en' }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const settingsRef = useRef(settings);
  const userId = localStorage.getItem("user") || null;
  const userSub = localStorage.getItem("userSub") || SUBSCRIPTION_CODES.free;
  const iframeTarget = settings.initialCharacter.id === "visper/neira" || settings.initialCharacter.id === 'visper/hvalena' ? IFRAME_TARGET_ORIGIN_LOWPOLY : IFRAME_TARGET_ORIGIN;

  useEffect(() => {
    settingsRef.current = settings;
  }, [settings]);

  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { type: "LANG_CHANGED", lang },
        iframeTarget
      );
    }
  }, [lang]);

  useEffect(() => {
    setTimeout(() => {
      handleIframeLoad();
    }, 5000)
  }, []);

  const handleIframeLoad = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { type: "LANG", lang },
        iframeTarget
      );

      iframeRef.current.contentWindow.postMessage(
        settings,
        iframeTarget
      );

      iframeRef.current.contentWindow.postMessage(
        { type: "USER_ID", userId },
        iframeTarget
      );

      iframeRef.current.contentWindow.postMessage(
        { type: "USER_SUB", userSub },
        iframeTarget
      );
    }
  };

  return (
    <iframe
      ref={iframeRef}
      src={iframeTarget}
      className={styles.iframe}
      width="100%"
      height="100%"
      title="Avatar player"
      allow="microphone"
      onLoad={handleIframeLoad}
      sandbox="allow-scripts allow-same-origin allow-modals allow-forms allow-popups allow-presentation"
    />
  );
};